import { useState } from "react";
import "../SMSSolutions/SMSSolutions.css";
import {
  FaArrowRight,
  FaBell,
  FaBuilding,
  FaBusinessTime,
  FaChartLine,
  FaCheckCircle,
  FaCode,
  FaGlobe,
  FaGraduationCap,
  FaHospital,
  FaLanguage,
  FaMobileAlt,
  FaPlane,
  FaShieldAlt,
  FaShoppingCart,
  FaSitemap,
  FaSyncAlt,
  FaUniversity,
  FaUsers,
} from "react-icons/fa";

const HEAD = {
  sendsms:  { method: 'GET/POST', path: '/api/sendsms' },
  delivery: { method: 'GET/POST', path: '/api/deliveryreport' },
  balance:  { method: 'GET/POST', path: '/api/balance' }
};

const PARAMS = {
  sendsms: [
    ['route', 'Route type — Promotional or Transactional'],
    ['senderid', 'Approved 6-character alphabetic sender ID'],
    ['message', 'URL-encoded message body'],
    ['mobilenumber', 'Destination number, without the 91 prefix'],
    ['userid / password', 'Account credentials'],
    ['teid', 'Template ID registered on the DLT portal']
  ],
  delivery: [
    ['userid / password', 'Account credentials'],
    ['txid', 'Transaction ID returned by the Send SMS response']
  ],
  balance: [
    ['userid / password', 'Account credentials']
  ]
};

const CODE = {
  sendsms: {
    curl:
`# Comment: send a transactional SMS
curl -G "https://enterprise.cloudsvas.com/api/sendsms" \\
  --data-urlencode "route=Transactional" \\
  --data-urlencode "senderid=XXXXXX" \\
  --data-urlencode "message=Hello" \\
  --data-urlencode "mobilenumber=9933XXXXXX" \\
  --data-urlencode "userid=xxxxx" \\
  --data-urlencode "password=xxxxx" \\
  --data-urlencode "teid=xxxxxxxxxxxxxx"`,
    node:
`// Comment: send a transactional SMS
const axios = require('axios');

const { data } = await axios.get('https://enterprise.cloudsvas.com/api/sendsms', {
  params: {
    route: 'Transactional',
    senderid: 'XXXXXX',
    message: 'Hello',
    mobilenumber: '9933XXXXXX',
    userid: 'xxxxx',
    password: 'xxxxx',
    teid: 'xxxxxxxxxxxxxx'
  }
});

console.log(data.ResponseMessage, data.TxId);`,
    python:
`# Comment: send a transactional SMS
import requests

params = {
    "route": "Transactional",
    "senderid": "XXXXXX",
    "message": "Hello",
    "mobilenumber": "9933XXXXXX",
    "userid": "xxxxx",
    "password": "xxxxx",
    "teid": "xxxxxxxxxxxxxx",
}

r = requests.get("https://enterprise.cloudsvas.com/api/sendsms", params=params)
print(r.json()["ResponseMessage"], r.json()["TxId"])`,
    php:
`<?php
// Comment: send a transactional SMS
$params = http_build_query([
    "route" => "Transactional",
    "senderid" => "XXXXXX",
    "message" => "Hello",
    "mobilenumber" => "9933XXXXXX",
    "userid" => "xxxxx",
    "password" => "xxxxx",
    "teid" => "xxxxxxxxxxxxxx",
]);

$response = file_get_contents("https://enterprise.cloudsvas.com/api/sendsms?" . $params);
$data = json_decode($response, true);
echo $data["ResponseMessage"];`
  },
  delivery: {
    curl:
`# Comment: check delivery status for a transaction
curl -G "https://enterprise.cloudsvas.com/api/deliveryreport" \\
  --data-urlencode "userid=xxxxx" \\
  --data-urlencode "password=xxxxx" \\
  --data-urlencode "txid=TXG6A27052020PZK233700070JRC"`,
    node:
`// Comment: check delivery status for a transaction
const axios = require('axios');

const { data } = await axios.get('https://enterprise.cloudsvas.com/api/deliveryreport', {
  params: {
    userid: 'xxxxx',
    password: 'xxxxx',
    txid: 'TXG6A27052020PZK233700070JRC'
  }
});

console.log(data.DeliveryReportList[0].Status);`,
    python:
`# Comment: check delivery status for a transaction
import requests

params = {
    "userid": "xxxxx",
    "password": "xxxxx",
    "txid": "TXG6A27052020PZK233700070JRC",
}

r = requests.get("https://enterprise.cloudsvas.com/api/deliveryreport", params=params)
print(r.json()["DeliveryReportList"][0]["Status"])`,
    php:
`<?php
// Comment: check delivery status for a transaction
$params = http_build_query([
    "userid" => "xxxxx",
    "password" => "xxxxx",
    "txid" => "TXG6A27052020PZK233700070JRC",
]);

$response = file_get_contents("https://enterprise.cloudsvas.com/api/deliveryreport?" . $params);
$data = json_decode($response, true);
echo $data["DeliveryReportList"][0]["Status"];`
  },
  balance: {
    curl:
`# Comment: check account balance
curl -G "https://enterprise.cloudsvas.com/api/balance" \\
  --data-urlencode "userid=xxxxx" \\
  --data-urlencode "password=xxxxx"`,
    node:
`// Comment: check account balance
const axios = require('axios');

const { data } = await axios.get('https://enterprise.cloudsvas.com/api/balance', {
  params: { userid: 'xxxxx', password: 'xxxxx' }
});

console.log(data.PromotionalBalance, data.TransactionalBalance);`,
    python:
`# Comment: check account balance
import requests

params = {"userid": "xxxxx", "password": "xxxxx"}
r = requests.get("https://enterprise.cloudsvas.com/api/balance", params=params)
print(r.json()["PromotionalBalance"], r.json()["TransactionalBalance"])`,
    php:
`<?php
// Comment: check account balance
$params = http_build_query(["userid" => "xxxxx", "password" => "xxxxx"]);
$response = file_get_contents("https://enterprise.cloudsvas.com/api/balance?" . $params);
$data = json_decode($response, true);
echo $data["PromotionalBalance"];`
  }
};

const SMSSolutions = () => {
  const [activeEndpoint, setActiveEndpoint] = useState('sendsms');
  const [activeLang, setActiveLang] = useState('curl');
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const text = CODE[activeEndpoint][activeLang];
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    });
  };

  const highlight = (code) => {
    let esc = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    esc = esc.replace(/(&quot;.*?&quot;|"[^"]*"|'[^']*')/g, '<span class="tok-str">$1</span>');
    esc = esc.replace(/(^|\n)(\s*(#|\/\/).*)/g, '$1<span class="tok-comment">$2</span>');
    return esc;
  };

  const stats = [
    { value: "99%+", label: "delivery success" },
    { value: "< 3s", label: "average dispatch" },
    { value: "2M+", label: "messages sent" },
    { value: "24/7", label: "delivery monitoring" },
  ];

  const featureCards = [
    {
      icon: <FaBell />,
      title: "Instant communication",
      description:
        "Reach customers within seconds for OTPs, alerts, reminders, and time-sensitive updates.",
    },
    {
      icon: <FaChartLine />,
      title: "High open rates",
      description:
        "SMS offers near-instant visibility and engagement, with far higher attention than email campaigns.",
    },
    {
      icon: <FaShieldAlt />,
      title: "DLT-compliant messaging",
      description:
        "Stay compliant with Indian regulations and protect your brand with approved templates and sender IDs.",
    },
    {
      icon: <FaCode />,
      title: "Developer-ready API",
      description:
        "Integrate campaigns, triggers, and reports directly with your CRM, ERP, or custom application.",
    },
  ];

  const processSteps = [
    { icon: <FaUsers />, label: "Customer list" },
    { icon: <FaSitemap />, label: "Campaign setup" },
    { icon: <FaSyncAlt />, label: "Route & send" },
    { icon: <FaChartLine />, label: "Live reports" },
  ];

  const industries = [
    { icon: <FaHospital />, label: "Healthcare" },
    { icon: <FaUniversity />, label: "Banking & Finance" },
    { icon: <FaShoppingCart />, label: "E-commerce" },
    { icon: <FaGraduationCap />, label: "Education" },
    { icon: <FaBuilding />, label: "Real Estate" },
    { icon: <FaPlane />, label: "Travel & Hospitality" },
  ];

  return (
    <>
      <div className="services-bannerff">
        <div className="overlayff"></div>
        <div className="contentff">
          <div className="lineff"></div>
          <div>
            <h1>Bulk SMS</h1>
            <p>
              Send high-impact messages to customers in seconds with a scalable,
              DLT-compliant Bulk SMS platform built for business growth.
            </p>
            {/* <p>
              <span className="homeff">Home</span> → Service → Bulk SMS
            </p> */}
          </div>
        </div>
      </div>

      <div className="sms-page">
        <section className="sms-hero reveal">
          <div className="sms-hero__content">
            <div className="sms-eyebrow">
              <span className="dot"></span>
              Bulk SMS Service · Multi-operator delivery
            </div>
            <h1>
              Reach every customer&apos;s inbox — <span className="accent">in seconds</span>, at scale
            </h1>
            <p>
              Send transactional, promotional, and OTP messages through a
              DLT-compliant gateway built for Indian businesses, with delivery
              reports you can check in real time.
            </p>
            <div className="sms-hero__cta">
              <a href="#api" className="btn btn-primary">
                View API docs
              </a>
              <a href="/contact-us" className="btn btn-outline">
                Talk to sales
              </a>
            </div>
          </div>

          <div className="sms-hero__visual" aria-label="SMS delivery dashboard preview">
            <div className="pulse-ring r1"></div>
            <div className="pulse-ring r2"></div>
            <div className="pulse-ring r3"></div>

            <div className="signal-card">
              <div className="signal-head">
                <span>LIVE DELIVERY</span>
                <span>INDIA</span>
              </div>

              <div className="signal-row">
                <span>OTP</span>
                <span className="num">12,480</span>
                <span className="status ok">online</span>
              </div>
              <div className="signal-row">
                <span>Promotional</span>
                <span className="num">4,210</span>
                <span className="status ok">ready</span>
              </div>
              <div className="signal-row">
                <span>Transactional</span>
                <span className="num">8,902</span>
                <span className="status wait">queue</span>
              </div>
              <div className="signal-row">
                <span>Regional</span>
                <span className="num">1,370</span>
                <span className="status ok">unicode</span>
              </div>
            </div>
          </div>
        </section>

        <section className="sms-stats">
          {stats.map((stat) => (
            <div className="sms-stat" key={stat.label}>
              <div className="sms-stat__num">
                {stat.value.split(" ")[0]}
                <span> {stat.value.split(" ")[1] || ""}</span>
              </div>
              <div className="sms-stat__label">{stat.label}</div>
            </div>
          ))}
        </section>

        <section className="sms-section">
          <div className="sms-section__head">
            <div className="eyebrow-sm">Why businesses choose us</div>
            <h2>Built for fast, reliable, and measurable outreach</h2>
            <p className="lead">
              Whether you are sending alerts, reminders, campaigns, or OTPs,
              our platform helps you deliver the right message to the right
              customer at the right time.
            </p>
          </div>

          <div className="card-grid">
            {featureCards.map((card) => (
              <div className="card" key={card.title}>
                <div className="icon-circle">{card.icon}</div>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="sms-section sms-section--muted">
          <div className="sms-section__head">
            <div className="eyebrow-sm">How it works</div>
            <h2>From campaign setup to delivery in four quick steps</h2>
          </div>

          <div className="flow">
            {processSteps.map((step, index) => (
              <div className="flow-step" key={step.label}>
                <div className="icon-circle">{step.icon}</div>
                <span>
                  {index + 1}. {step.label}
                </span>
              </div>
            ))}
            <div className="flow-arrow" aria-hidden="true"></div>
          </div>
        </section>

        <section className="sms-section">
          <div className="sms-two-col">
            <div>
              <div className="eyebrow-sm">What is bulk SMS?</div>
              <h2>Fast, direct, and highly effective customer communication</h2>
              <p className="lead">
                A bulk SMS service enables businesses to send large volumes of
                messages in a single action. These can be promotional,
                transactional, or informational, depending on business needs.
                Unlike email or social media, SMS lands directly in the
                customer&apos;s phone inbox and gets seen quickly.
              </p>
              <ul className="sms-list">
                <li>
                  <FaCheckCircle /> Send promotional updates to opted-in users
                </li>
                <li>
                  <FaCheckCircle /> Trigger OTPs, order alerts, and account notices
                </li>
                <li>
                  <FaCheckCircle /> Integrate with your CRM, ERP, or application
                </li>
              </ul>
            </div>

            <div className="sms-visual-box">
              <div className="sms-visual-box__header">
                <span className="sms-visual-box__dot"></span>
                <span>Campaign Health</span>
              </div>
              <div className="sms-chart">
                <div className="sms-chart__bar bar-1"></div>
                <div className="sms-chart__bar bar-2"></div>
                <div className="sms-chart__bar bar-3"></div>
                <div className="sms-chart__bar bar-4"></div>
                <div className="sms-chart__bar bar-5"></div>
              </div>
              <div className="sms-visual-box__grid">
                <div>
                  <strong>2.4 Lakhs</strong>
                  <span>messages today</span>
                </div>
                <div>
                  <strong>97.8%</strong>
                  <span>success rate</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sms-section sms-section--muted">
          <div className="sms-section__head">
            <div className="eyebrow-sm">Industries we serve</div>
            <h2>Trusted by teams that need timely communication</h2>
          </div>

          <div className="industry-grid">
            {industries.map((industry) => (
              <div className="industry" key={industry.label}>
                <div className="icon-circle">{industry.icon}</div>
                <span>{industry.label}</span>
              </div>
            ))}
          </div>
        </section>

        <section id="api" className="sms-section api-section">
          <div className="sms-section__head">
            <div className="eyebrow-sm">DEVELOPER REFERENCE</div>
            <h2>SMS API</h2>
            <p className="lead">
              Three endpoints: send a message, check delivery status, and check
              account balance. Sample requests below in cURL, Node.js, Python and PHP.
            </p>
          </div>

          <div className="api-tabs">
            <span
              className={`api-tab ${activeEndpoint === 'sendsms' ? 'active' : ''}`}
              onClick={() => setActiveEndpoint('sendsms')}
            >
              Send SMS
            </span>
            <span
              className={`api-tab ${activeEndpoint === 'delivery' ? 'active' : ''}`}
              onClick={() => setActiveEndpoint('delivery')}
            >
              Delivery report
            </span>
            <span
              className={`api-tab ${activeEndpoint === 'balance' ? 'active' : ''}`}
              onClick={() => setActiveEndpoint('balance')}
            >
              Balance enquiry
            </span>
          </div>

          <div className="lang-tabs">
            <span
              className={`lang-tab ${activeLang === 'curl' ? 'active' : ''}`}
              onClick={() => setActiveLang('curl')}
            >
              cURL
            </span>
            <span
              className={`lang-tab ${activeLang === 'node' ? 'active' : ''}`}
              onClick={() => setActiveLang('node')}
            >
              Node.js
            </span>
            <span
              className={`lang-tab ${activeLang === 'python' ? 'active' : ''}`}
              onClick={() => setActiveLang('python')}
            >
              Python
            </span>
            <span
              className={`lang-tab ${activeLang === 'php' ? 'active' : ''}`}
              onClick={() => setActiveLang('php')}
            >
              PHP
            </span>
          </div>

          <div className="code-panel">
            <div className="code-head">
              <span>
                <span className="tok-method">{HEAD[activeEndpoint].method}</span> {HEAD[activeEndpoint].path}
              </span>
              <button
                type="button"
                className={`copy-btn ${copied ? 'copied' : ''}`}
                onClick={handleCopy}
              >
                {copied ? 'Copied' : 'Copy'}
              </button>
            </div>
            <pre
              className="code-body"
              dangerouslySetInnerHTML={{ __html: highlight(CODE[activeEndpoint][activeLang]) }}
            />
          </div>

          <table className="param-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {PARAMS[activeEndpoint].map((param, index) => (
                <tr key={index}>
                  <td>{param[0]}</td>
                  <td>{param[1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="sms-section sms-section--muted">
          <div className="sms-section__head">
            <div className="eyebrow-sm">Security &amp; compliance</div>
            <h2>Built around TRAI&apos;s DLT framework</h2>
          </div>

          <div className="choose-grid">
            <div className="choose-box">
              <FaShieldAlt />
              <h3>DLT-registered by default</h3>
              <p>
                Your entity, sender ID and message templates are registered on the DLT
                platform before you go live, as TRAI requires.
              </p>
            </div>
            <div className="choose-box">
              <FaGlobe />
              <h3>Encrypted in transit</h3>
              <p>
                API requests are made over HTTPS, and dashboard access sits behind
                authenticated login.
              </p>
            </div>
            <div className="choose-box">
              <FaBusinessTime />
              <h3>DND-aware routing</h3>
              <p>
                Promotional traffic is filtered against the national DND registry so you
                don&apos;t send campaigns where they&apos;re not permitted.
              </p>
            </div>
          </div>
        </section>

        <section className="sms-section">
          <div className="sms-section__head sms-section__head--center">
            <div className="eyebrow-sm">Why choose us</div>
            <h2>Dependable delivery with support that scales with you</h2>
          </div>

          <div className="choose-grid">
            <div className="choose-box">
              <FaMobileAlt />
              <h3>Fast and reliable dispatch</h3>
              <p>High-priority routing designed for time-sensitive business communication.</p>
            </div>
            <div className="choose-box">
              <FaGlobe />
              <h3>Regional language support</h3>
              <p>Send Unicode-ready messages in Hindi and other Indian regional formats.</p>
            </div>
            <div className="choose-box">
              <FaBusinessTime />
              <h3>Dedicated support</h3>
              <p>Our specialists help you onboard, configure templates, and monitor delivery.</p>
            </div>
            <div className="choose-box">
              <FaLanguage />
              <h3>Easy-to-use dashboard</h3>
              <p>Track campaign health, delivery logs, and message reports without complexity.</p>
            </div>
          </div>
        </section>

        <section className="cta-band">
          <h3>Need a messaging partner for growth, alerts, and the next campaign?</h3>
          <a href="/contact-us" className="btn btn-primary">
            Let&apos;s talk <FaArrowRight />
          </a>
        </section>

        <section className="sms-section faq-section">
          <div className="sms-section__head">
            <div className="eyebrow-sm">FAQ</div>
            <h2>Common questions about bulk SMS</h2>
          </div>

          <details className="faq-item" open>
            <summary>
              What is DLT registration and why is it required?
              <span className="plus"></span>
            </summary>
            <p>
              DLT registration is mandatory for businesses sending commercial SMS
              in India. It verifies your entity, approved sender ID, and template
              before messages are routed to customers.
            </p>
          </details>

          <details className="faq-item">
            <summary>
              How fast are OTP and transactional messages delivered?
              <span className="plus"></span>
            </summary>
            <p>
              Transactional messages, including OTPs, are prioritized and typically
              reach customers within seconds, depending on network conditions.
            </p>
          </details>

          <details className="faq-item">
            <summary>
              Can I send SMS in regional Indian languages?
              <span className="plus"></span>
            </summary>
            <p>
              Yes. The gateway supports Unicode SMS, so you can send messages in
              Hindi, Bengali, Tamil, and other regional languages with proper
              encoding.
            </p>
          </details>

          <details className="faq-item">
            <summary>
              What is the difference between transactional and promotional routes?
              <span className="plus"></span>
            </summary>
            <p>
              Transactional routes are used for alerts, OTPs, and confirmations,
              while promotional routes are used for marketing campaigns and only
              reach opted-in audiences.
            </p>
          </details>
        </section>
      </div>
    </>
  );
};

export default SMSSolutions;
